import React, { useState } from 'react';
import { showToast } from './Toast';

function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      showToast('ขอบคุณสำหรับการติดตาม! เราได้บันทึกอีเมลของคุณแล้ว');
      setEmail('');
    }
  };

  return (
    <footer>
      {/* Top Main Footer: Aegean Slate Blue Banner matching reference image */}
      <div className="bg-[#4E74A6] text-white py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 items-start">
          
          {/* Column 1: Find a Store */}
          <div className="flex items-start space-x-4">
            <div className="w-11 h-11 rounded-full border border-white/40 bg-white/10 flex items-center justify-center shrink-0 text-white">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-[0.18em] font-bold text-white mb-1">
                Find A Store
              </h4>
              <p className="text-[12px] text-white/80 font-light leading-relaxed">
                Visit us in Bangkok & delivery across city areas.
              </p>
            </div>
          </div>

          {/* Column 2: Open Daily */}
          <div className="flex items-start space-x-4">
            <div className="w-11 h-11 rounded-full border border-white/40 bg-white/10 flex items-center justify-center shrink-0 text-white">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-[0.18em] font-bold text-white mb-1">
                Open Daily
              </h4>
              <p className="text-[12px] text-white/80 font-light leading-relaxed">
                7:00 AM – 7:00 PM <br />
                <span className="text-[11px] text-white/60">เปิดให้บริการทุกวันพร้อมส่ง</span>
              </p>
            </div>
          </div>

          {/* Column 3: Follow Us */}
          <div className="flex items-start space-x-4">
            <div className="w-11 h-11 rounded-2xl border border-white/40 bg-white/10 flex items-center justify-center shrink-0 text-white">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </div>
            <div>
              <h4 className="text-xs uppercase tracking-[0.18em] font-bold text-white mb-1">
                Follow Us
              </h4>
              <p className="text-[12px] text-white/80 font-light leading-relaxed">
                <a href="https://instagram.com" target="_blank" rel="noreferrer" className="hover:underline">
                  @davigreekyogurt
                </a>
                <br />
                <span className="text-[11px] text-white/60">LINE: NUTCHEEFUL</span>
              </p>
            </div>
          </div>

          {/* Column 4: Newsletter */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] font-bold text-white mb-1">
              Newsletter
            </h4>
            <p className="text-[12px] text-white/80 font-light mb-3">
              Sign up for updates & special offers.
            </p>
            <form onSubmit={handleSubscribe} className="relative flex items-center">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                required
                className="w-full bg-white text-brand-900 placeholder-brand-400 text-xs rounded-full pl-4 pr-11 py-2.5 outline-none shadow-inner"
              />
              <button
                type="submit"
                className="absolute right-1 w-8 h-8 rounded-full bg-[#3B689C] text-white flex items-center justify-center hover:bg-[#2A5180] transition-colors"
                aria-label="Subscribe"
              >
                <i className="fas fa-arrow-right text-[11px]"></i>
              </button>
            </form>
          </div>

        </div>
      </div>

      {/* Bottom Micro Footer: Clean porcelain with olive sprig matching image */}
      <div className="bg-[#FAFBFD] border-t border-brand-200/60 py-6 px-4 sm:px-6 lg:px-8 text-brand-600/80">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-[11px] tracking-wider uppercase font-medium">
          
          {/* Copyright */}
          <div>
            © 2026 DA'VI / Sunday Dairy Greek Yogurt & Croissant. All rights reserved.
          </div>

          {/* Links + Olive sprig */}
          <div className="flex items-center space-x-6">
            <a href="#about" className="hover:text-brand-800 transition-colors">
              Privacy Policy
            </a>
            <a href="#contact" className="hover:text-brand-800 transition-colors">
              Terms of Service
            </a>
            
            {/* Olive sprig icon */}
            <svg className="w-5 h-5 text-brand-500 transform rotate-45 inline-block" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 20c4-4 8-9 16-16" />
              <path d="M10 8c-2 0-3 2-3 2s2 1 3 0" fill="currentColor" fillOpacity="0.25" />
              <path d="M14 12c-2 0-3 2-3 2s2 1 3 0" fill="currentColor" fillOpacity="0.25" />
              <path d="M12 6c0-2 2-3 2-3s1 2 0 3" fill="currentColor" fillOpacity="0.25" />
              <path d="M16 10c0-2 2-3 2-3s1 2 0 3" fill="currentColor" fillOpacity="0.25" />
              <path d="M8 14c-2 0-3 2-3 2s2 1 3 0" fill="currentColor" fillOpacity="0.25" />
            </svg>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
